export default __webpack_public_path__ + "static/media/app_shake.bf9f63be.png";